// The shell constructs a single SDK Client and injects it everywhere —
// the federated remotes receive it through their props rather than each
// MFE building its own. This guarantees a consistent base URL, a single
// cookie jar (so CSRF + session cookies are shared), and one place to
// add per-request observability hooks (request-id propagation, log
// breadcrumbs) when those land.
//
// VITE_API_BASE_URL overrides the default `window.location.origin`
// (useful in `pnpm dev` when the API is on :8080 but the shell is on
// :5173). At production the origin is the same as the shell's, so the
// env var is unset.

import { Client } from "@sms/sdk";

const env = (import.meta.env ?? {}) as Record<string, string | undefined>;

export const apiClient = new Client({
  baseURL: env.VITE_API_BASE_URL ?? (typeof window !== "undefined" ? window.location.origin : ""),
});
